import React from 'react';
import { VStack, Text } from '@chakra-ui/react';
import HeroSection from '../components/common/HeroSection';
import Content from '../components/selectivemutism/Content';
import MiniNavbar from '../components/common/MiniNavbar'; 

const SelectiveMutism = () => {
    return (
        <VStack spacing={0}>
            <HeroSection />
            {/* <JoinCommunity from={"kidssmass"}/> */}
            <MiniNavbar /> 
            <Content/>
        </VStack>
    );
};

export default SelectiveMutism;
